import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SidebarMenuComponent} from './sidebar-menu.component';
import {RouterModule} from '@angular/router';
import { CustomerSupportService } from '../../services/customer-support.service';


@NgModule({
  declarations: [
    SidebarMenuComponent
  ],
  exports: [
    SidebarMenuComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
  ],
})
export class SidebarMenuModule {
}
